import React from 'react';
import { OptionProps } from 'react-select';
import cn from 'classnames';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IPortalAvailableMilestonesDTO } from '@interfaces/portal/dto/taskManagementDTO';

import styles from './MilestoneSelectOption.module.scss';

const MilestoneSelectOption = (props: OptionProps<TSelectOption & IPortalAvailableMilestonesDTO>) => {
	const {
		selectOption,
		data: { title, startDate, endDate },
	} = props;

	const handleSelect = () => {
		selectOption(props.data);
	};

	return (
		<div
			className={cn(styles.presetsOption, {
				[styles.active]: props.isSelected,
			})}
			onClick={handleSelect}
		>
			<div className={styles.title}>
				{title}
			</div>
			<div className={styles.dates}>
				{`${startDate} - ${endDate}`}
			</div>
		</div>
	);
};

export default MilestoneSelectOption;
